<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { Hero3 } from '../../../types';

  export let img: string;
  export let pricingTag: Hero3['pricingTag'];

  const dispatch = createEventDispatcher();
  console.log('pricingTag', pricingTag);
  function handleClick() {
    dispatch('nextStep', { step: 'second' }); // Dispatch 'nextStep' event with new step value
  }
</script>

<div
  class="relative flex h-full w-full items-center justify-center rounded-3xl bg-cover bg-no-repeat py-[44%]"
  style="background-image: url('{img}'); background-position: center;"
>
  {#if pricingTag.content.active}
    <div
      class="absolute bottom-5 left-0 right-0 flex justify-center px-6 sm:bottom-10"
    >
      <button
        class="w-auto rounded-full border border-[6px] bg-transparent px-6 py-3 transition-all duration-300 hover:shadow-lg sm:px-8"
        on:click={handleClick}
        aria-label="Next Step"
        style="background-color: {pricingTag.customColor.active
          ? pricingTag.customColor.color
          : '#8DC63F'}; border-color: {pricingTag.customColor.active
          ? 'transparent'
          : '#709D32'};"
      >
        <span class="button-text text-lg font-bold text-white sm:text-2xl"
          >{pricingTag.content.value}</span
        >
      </button>
    </div>
  {/if}
</div>

<style scoped>
  .button-text {
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
  }
</style>
